export default {
  headerContent: {
    title: 'HDI Sigorta Seyahat Sağlık Sigortası Ücretleri',
    slogan: "Seyahat Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'SEYAHAT SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'HDI Sigorta Seyahat Sağlık Sigortası',
    description: {
      title: 'HDI Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Seyahat sağlık sigortası poliçesi, yolculuğunuzu güvenli ve keyifli hale getirmenizi sağlar. ',
        'Yapmak istediğiniz yolculuğu planlamak için çok zaman harcıyorsunuz. Tüm endişeleri ve stresi geride bırakarak daha önce hiç olmadığı kadar tatilinizin tadını çıkarmak istiyorsunuz. Bu heyecanın ortasında, çoğu kişi genellikle bir kazayla karşılaşma veya hastalanma gibi öngörülemeyen durumların olasılığını gözden kaçırma eğilimindedir. Bu nedenle, sonuçlara göğüs germeye hazırlıklı olunmalıdır. ',
        'Seyahatiniz sırasında karşılaşabileceğiniz risk durumlarını ortadan kaldırmak için Hdi Sigorta seyahat sağlık sigortası en uygun fiyat ile yanınızda!'
      ]
    },
    subContent: {
      title: 'HDI Sigorta Seyahat Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Yurt içi ve yurt dışı seyahatlerinizde tam 15 ayrı riske karşı güvence sağlayan HDI Seyahat Sağlık Sigortası kapsamında:',
          subList: [
            'Acil mesajların iletilmesi',
            'Aile üyelerinden birinin ölümü nedeniyle yolculuğun durdurulması sonucu geri dönüş seyahati',
            'Bagajın bulunması ve sigortalıya ulaştırılması',
            'Evde meydana gelen hasar nedeniyle yolculuğun durdurulması sonucu geri dönüş seyahati',
            'Gecikmeli bagaj',
            'İlaç gönderilmesi organizasyonu',
            'Kanuni işlemlerle ilgili kefalet (borç olarak)',
            'Sigortalıya yapılacak tedavi nedeniyle aile üyelerinden birinin konaklaması',
            'Sigortalıya yapılacak tedavi nedeniyle aile üyelerinden birinin seyahati',
            'Taburcu olduktan sonra daimî ikametgâha nakil',
            'Tarifeli bagaj kaybı, zarar görmesi, çalınması',
            'Vefat eden sigortalının nakli',
            'Yaralanma veya hastalık nedeniyle sigortalının nakli',
            'Yaralanma veya hastalık nedeniyle tıbbi tedavi',
            'Yaralanma veya hastalık nedeniyle yurt dışında konaklama süresinin uzatılması bulunmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Seyahat Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'HDI Sigorta Seyahat Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
